import React, { useState } from 'react';
import { streamAI } from '../utils/streamAI';

const SUGGESTIONS = {
  daily: ['Suggest my top 3 priorities for today', 'What daily tasks should a small honey business never skip?'],
  weekly: ['Help me plan this week around a Saturday market', 'What should my 3 goals be this week?'],
  market: ['Build me a market day checklist', 'Tips to sell more honey at a tasting table'],
  social: ['Reel idea about honey crystallisation', 'Caption for a Golden Morning product photo', 'Behind-the-scenes jar filling post'],
  wholesale: ['Write a short pitch to a local grocer', 'How should I follow up a cafe that got samples?'],
  monthly: ['Help me review this month and set next month\'s top 3'],
  sales: ['How can I lift website sales this month?'],
  inventory: ['How much stock should I hold before a big market?'],
  production: ['Checklist for a clean, safe jarring session'],
  orders: ['How do I speed up my packing process?'],
};

const AiAssist = ({ planner, entryData }) => {
  const [open, setOpen] = useState(false);
  const [prompt, setPrompt] = useState('');
  const [output, setOutput] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const mode = planner.id === 'social' ? 'social' : 'planner';
  const suggestions = SUGGESTIONS[planner.id] || [];

  const run = async (text) => {
    const p = (text || prompt).trim();
    if (!p || busy) return;
    setBusy(true);
    setError('');
    setOutput('');
    const context = `Planner: ${planner.title}. Current page data: ${JSON.stringify(entryData).slice(0, 3000)}`;
    await streamAI('/api/ai/generate', { mode, prompt: p, context },
      (chunk) => setOutput(prev => prev + chunk),
      () => setBusy(false),
      (err) => { setError(err); setBusy(false); });
  };

  return (
    <div className="rb-no-print" style={{ maxWidth: 860, margin: '20px auto 0', padding: '0 12px' }}>
      <button className={`rb-btn ${open ? 'rb-active' : ''}`} onClick={() => setOpen(o => !o)} data-testid="ai-assist-toggle">
        ✦ AI Assistant {open ? '—' : '+'}
      </button>
      {open && (
        <div style={{ background: '#fff', border: '1px solid rgba(36,36,36,0.1)', borderRadius: 12, padding: 20, marginTop: 10 }} data-testid="ai-assist-panel">
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
            {suggestions.map(s => (
              <button key={s} className="rb-btn" style={{ fontSize: '0.68rem' }} onClick={() => { setPrompt(s); run(s); }} data-testid="ai-suggestion">{s}</button>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <input className="rb-select" style={{ flex: 1 }} value={prompt} onChange={e => setPrompt(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') run(); }}
              placeholder={mode === 'social' ? 'e.g. Reel about spring honey harvest...' : 'Ask for planning help...'}
              data-testid="ai-prompt-input" />
            <button className="rb-btn rb-primary" onClick={() => run()} disabled={busy || !prompt.trim()} data-testid="ai-generate-btn">
              {busy ? 'Thinking...' : 'Generate'}
            </button>
          </div>
          {error && <p style={{ color: '#b91c1c', fontSize: '0.75rem', marginTop: 8 }} data-testid="ai-error">{error}</p>}
          {output && (
            <div style={{ marginTop: 14, fontSize: '0.82rem', lineHeight: 1.65, whiteSpace: 'pre-wrap', borderTop: '1px solid #D9C9A7', paddingTop: 12 }} data-testid="ai-output">
              {output}
              <div style={{ marginTop: 10 }}>
                <button className="rb-btn" onClick={() => navigator.clipboard.writeText(output)} data-testid="ai-copy-btn">Copy</button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AiAssist;
